import { Configuration } from '@coretava/api/core-service';
import { createAxiosWithTokenRefresh, TokenRefreshConfig } from '@gamiphy/http';
import { AxiosInstance } from 'axios';

/**
 * Base configuration for all API instances
 */
const getBaseConfig = (): Configuration => ({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
});

/**
 * Store the current app ID globally for the interceptors to access
 */
let currentAppId: string | undefined;

export const setCurrentAppId = (appId: string | undefined): void => {
  currentAppId = appId;
};

export const getStoredAppId = (): string | undefined => currentAppId;

/**
 * Create axios instances for each service with token refresh interceptor
 */
const createAxiosWithRefresh = (): AxiosInstance => {
  const config: TokenRefreshConfig = {
    getAppId: getStoredAppId,
    enableCredentials: true,
  };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
  return createAxiosWithTokenRefresh(config);
};

export const createCoreAxios = (): AxiosInstance => createAxiosWithRefresh();

export const createSecurityAxios = (): AxiosInstance => createAxiosWithRefresh();

export const createEcommerceAxios = (): AxiosInstance => createAxiosWithRefresh();

export const createEventsAxios = (): AxiosInstance => createAxiosWithRefresh();

export { getBaseConfig };
